var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgKattana(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 200,
    height: 46,
    viewBox: "0 0 200 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M45.1816 0H0V45.1816H45.1816V0Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M33.1004 24.2783H26.2568H18.7149H9.59017L5.44678 30.0046H12.6861L6.63393 38.3146H15.5026L21.6013 30.0046H28.957L33.1004 24.2783Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M12.0811 20.8563H18.9712H26.5131H35.5913L39.7347 15.1533H32.3325L38.3613 6.84326H29.5159L23.487 15.1533H16.2244L12.0811 20.8563Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M57.9375 29.3065V16.5737H61.3127V21.2991H62.7792L65.8751 16.5737H69.6926L65.6889 22.5793L69.972 29.3065H66.1544L62.9422 24.395H61.3127V29.3065H57.9375Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M79.0503 29.3065L82.4954 16.5737H88.6872L92.1322 29.3065H88.6872L88.0587 26.7693H83.1471L82.5186 29.3065H79.0503ZM83.8687 23.8596H87.3138L86.2197 19.6696H84.9395L83.8687 23.8596Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M100.698 19.6696V16.5737H112.058V19.6696H108.054V29.3065H104.679V19.6696H100.698Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M121.532 19.6696V16.5737H132.891V19.6696H128.887V29.3065H125.512V19.6696H121.532Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M141.457 29.3065L144.902 16.5737H151.094L154.539 29.3065H151.094L150.465 26.7693H145.554L144.925 29.3065H141.457ZM146.275 23.8596H149.721L148.626 19.6696H147.346L146.275 23.8596Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M164.828 29.3065V16.5737H168.924L173.37 24.5812H173.557L173.277 22.9517V16.5737H176.653V29.3065H172.556L168.11 21.2991H167.924L168.203 22.9285V29.3065H164.828Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    d: "M186.918 29.3065L190.363 16.5737H196.555L200 29.3065H196.555L195.926 26.7693H191.015L190.386 29.3065H186.918ZM191.76 23.8596H195.205L194.111 19.6696H192.83L191.76 23.8596Z",
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKattana);
export default __webpack_public_path__ + "static/media/kattana.85bcc16e797f4b94be28e208a368070e.svg";
export { ForwardRef as ReactComponent };